import type { CalendarHolidayInfo, HolidaySuggestion } from '@/store/proactive/proactive.mappers';

import { Button, ButtonOutlined } from '../Button';
import Modal from '../Modal/Modal';

import s from './HolidaySuggestionModal.module.scss';

type HolidayTodayModalProps = {
  holiday: CalendarHolidayInfo;
  /** The live idea for today's holiday, if there is one. */
  suggestion?: HolidaySuggestion;
  onClose: () => void;
  onOpenIdea: () => void;
  onGetIdea: () => void;
  onPlan: () => void;
  /** An idea is being fetched. */
  busy?: boolean;
};

/**
 * "Today is Halloween" — shown once on the holiday itself. Points to the idea
 * when there is one, offers to ask for one when the agent writes ideas for this
 * holiday, and always lets the owner plan something. Presentational; the mount
 * decides when it shows.
 */
export const HolidayTodayModal = ({
  holiday,
  suggestion,
  onClose,
  onOpenIdea,
  onGetIdea,
  onPlan,
  busy = false,
}: HolidayTodayModalProps) => (
  <Modal open onClose={onClose} title={`Today Is ${holiday.name}`}>
    <div className={s.body}>
      <p className={s.eyebrow}>
        <span className={s.mark} aria-hidden="true">
          ✦
        </span>
        {holiday.date.toLocaleDateString('en-US', {
          weekday: 'long',
          month: 'long',
          day: 'numeric',
        })}
      </p>
      <p className={s.description}>
        {suggestion
          ? `There’s an idea waiting for today: ${suggestion.title}.`
          : `It’s ${holiday.name}. Would you like to plan something on the water?`}
      </p>
      <div className={s.actions}>
        <ButtonOutlined type="button" onClick={onPlan} disabled={busy}>
          Plan Event
        </ButtonOutlined>
        {suggestion ? (
          <Button type="button" onClick={onOpenIdea}>
            Open Idea
          </Button>
        ) : (
          holiday.ideas && (
            <Button type="button" onClick={onGetIdea} disabled={busy}>
              {busy ? 'Getting Idea…' : 'Get AI Idea'}
            </Button>
          )
        )}
      </div>
    </div>
  </Modal>
);

export default HolidayTodayModal;
